module.exports = __webpack_public_path__ + "img/ok.924a0cea.svg";